import { For } from "solid-js";
import { PROFILES } from "../config/profiles";
import { useProfile } from "../contexts/ProfileContext";

const ProfileSelectPage = () => {
  const { setProfile } = useProfile();

  const handleSelect = (profileId: string) => {
    setProfile(profileId);
    if (typeof window !== "undefined") {
      window.location.replace("/login");
    }
  };

  return (
    <div class="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center px-4 py-10">
      <div class="w-full max-w-4xl space-y-10">
        <div class="text-center space-y-3">
          <h1 class="text-4xl font-bold text-blue-600">IntelliCoach</h1>
          <h2 class="text-2xl font-semibold text-gray-900">
            Select a client profile
          </h2>
        </div>

        <div class="grid gap-6 md:grid-cols-2">
          <For each={PROFILES}>
            {(profile) => (
              <button
                type="button"
                onClick={() => handleSelect(profile.id)}
                class="group relative bg-white rounded-xl shadow-sm border border-transparent hover:border-blue-500 transition-all text-left p-6 flex flex-col h-full"
              >
                <div
                  class="h-1.5 w-16 rounded-full mb-5"
                  style={{ "background-color": profile.accentColor }}
                />
                <div class="flex-1 space-y-3">
                  <h3
                    class={`text-xl font-semibold ${profile.accentTextClass}`}
                  >
                    {profile.name}
                  </h3>
                  <p class="text-sm text-gray-600 leading-relaxed">
                    {profile.description}
                  </p>
                </div>
                <div class="mt-6 flex items-center justify-between text-sm text-gray-500">
                  <span>Use this profile</span>
                  <svg
                    class="w-5 h-5 transform transition-transform group-hover:translate-x-1 text-gray-400 group-hover:text-blue-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    />
                  </svg>
                </div>
              </button>
            )}
          </For>
        </div>

        <div class="text-center text-xs text-gray-500">
          You can switch clients later from the profile menu inside the app.
        </div>
      </div>
    </div>
  );
};

export default ProfileSelectPage;
